<template>
  <div>
    <Main
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @openDetailDialog="openDetailDialog"
      ref="tableMain"
    >
      <Header
        ref="tableHeader"
        slot="header"
        :disabled="disabled"
        @openDetailDialog="openDetailDialog"
        @batchDel="$refs.tableMain.removeCheckboxRow()"
      />
    </Main>

    <el-dialog
      v-if="bankDetailDialogParams.visible"
      show-close
      :visible.sync="bankDetailDialogParams.visible"
      width="1000px"
      :title="bankDetailDialogParams.title"
      :close-on-click-modal="false"
      :before-close="() => (bankDetailDialogParams.visible = false)"
      v-el-dialog-drag
      append-to-body
    >
      <DetailForm
        ref="detailForm"
        :disabled="bankDetailDialogParams.disabled"
        :form="bankDetailDialogParams.form"
        :type="bankDetailDialogParams.type"
      />
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!bankDetailDialogParams.disabled"
          @click="save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
import DetailForm from '../detail'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main, Header, DetailForm },
  props: {
    custCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      bankDetailDialogParams: {
        visible: false,
        title: '',
        type: '',
        disabled: false,
        form: {},
      },
    }
  },
  watch: {
    custCode: {
      handler(custCode) {
        if (custCode !== '') {
          this.getData()
        }
      },
      immediate: true,
    },
  },
  methods: {
    getData() {
      if (this.custCode) {
        this.loading = true
        this.$api
          .masterCustomerBankListApi({ custCode: this.custCode })
          .then((res) => {
            this.loading = false
            this.tableData = res.body.data
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    openDetailDialog({ type, form = {} }) {
      const types = {
        add: this.$l('INDEX.form_label_add_bank_account_information') ||'添加银行账号信息',
        edit: this.$l('INDEX.form_label_edit_bank_account_information') ||'编辑银行账号信息',
        detail: this.$l('INDEX.form_label_bank_account_details') || '银行账号详情',
      }
      if (!form.uuid) {
        form.uuid = this.getUUID()
      }
      this.bankDetailDialogParams = {
        visible: true,
        title: types[type],
        form,
        type: type,
        disabled: type === 'detail',
      }
    },
    batchDel() {
      const listCode = this.$refs.tableMain.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    save() {
      this.$refs.detailForm.getForm().then((res) => {
        if (!res) return
        for (let index = 0; index < this.tableData.length; index++) {
          if (res.uuid === this.tableData[index].uuid) {
            this.$set(this.tableData, index, res)
            this.close()
            return
          }
        }
        this.tableData.push(res)
        this.close()
      })
    },
    close() {
      this.bankDetailDialogParams.visible = false
    },
    getTableData() {
      return this.tableData
    },
    getUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
  },
}
</script>
